export const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
export const deploymentName = process.env.NEXT_PUBLIC_DEPLOYMENT_NAME;

export const isProd = environment === 'prod';
export const isStaging = environment === 'staging';
